import { useEffect, useState } from "react";
import "src/types/window";

type CookieConsentStatus = "accepted" | "declined" | "pending";

const evaluateCookieState = (shouldStopPolling: boolean): CookieConsentStatus => {
  const optInStatus = window.digitaldata?.user?.optInStatus;
  const onclickStatus = window.digitaldata?.onclick?.onclick;

  if (optInStatus?.includes("performance:yes") || onclickStatus?.includes("accept")) {
    return "accepted";
  } else if (optInStatus?.includes("performance:no") && onclickStatus?.includes("decline")) {
    return "declined";
  } else if (optInStatus?.includes("performance:no") && shouldStopPolling) {
    return "declined";
  }
  return "pending";
};

export const useCookiesPoll = (shouldStopPolling: boolean) => {
  const [performanceCookiesEnabled, setPerformanceCookiesEnabled] = useState<boolean>(false);

  useEffect(() => {
    const initialDecision = evaluateCookieState(shouldStopPolling);

    if (initialDecision === "accepted") {
      setPerformanceCookiesEnabled(true);
      return;
    } else if (initialDecision === "declined") {
      setPerformanceCookiesEnabled(false);
      return;
    }

    const checkCookieInterval = setInterval(() => {
      const decision = evaluateCookieState(shouldStopPolling);
      if (decision === "accepted") {
        setPerformanceCookiesEnabled(true);
        clearInterval(checkCookieInterval);
      } else if (decision === "declined") {
        setPerformanceCookiesEnabled(false);
        clearInterval(checkCookieInterval);
      }
    }, 5000);

    return () => {
      clearInterval(checkCookieInterval);
    };
  }, [shouldStopPolling]);

  return performanceCookiesEnabled;
};
